
import { Sale } from "@/models/base";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import {printHumanFloat} from "../../utils/pretty-print";
import {ClientPortalService} from "@/services";
import {base64ToBlob, downloadBlob} from "@/utils/blob";

export default Vue.extend({
	filters: {
		printHumanFloat,
	},
	data() {
		return {
			token: "",
			canSign: true
		};
	},
	props: {
		estimate: {
			type: Object as ()=>Sale,
			required: true
		},
		showTotal: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		saleTypeName():string | TranslateResult{
			let defaultValue = this.$ct("Document");
			if (!this.estimate.Type) {
				return defaultValue;
			}
			return this.estimate.Type.Name.getTranslation(this.estimate.getLng()) || defaultValue;
		},
		computedFriendlyId():string {
			return this.estimate.getOriginalComputedFriendlyIDFromSaldoDocument();
		},
		isSigned():boolean {
			return this.estimate.SignatureImageToken != "";
		}
	},
	methods: {
		onClick(){
			this.$emit("click");
		},
		sign(){
			this.$emit("sign");
		},
		async download():Promise<any> {
			let token = await ClientPortalService.getSalePublicToken(this.token, this.estimate.ID);
			let file = await ClientPortalService.downloadSaleAsBlob(token);
			downloadBlob(base64ToBlob(file.Data, file.MimeType), file.FileName);
		},
	},
	async created() {
	},
	mounted(){
		this.token = this.$route.params.token;
	},
	components: {
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
